<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "SELECT_CLIENT.TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div class="filter-row flex-row-space-between-start">
      <mat-radio-group
        class="clients-radio-group"
        (ngModelChange)="reloadClients($event)"
        [(ngModel)]="clientType"
      >
        <mat-radio-button
          class="clients-radio-button dialog-subtitle text-bold"
          value="client"
        >
          {{ "SELECT_CLIENT.BY_CLIENT" | translate }}
        </mat-radio-button>
        <mat-radio-button
          class="clients-radio-button dialog-subtitle text-bold"
          value="enterprise"
        >
          {{ "SELECT_CLIENT.BY_ENTERPRISE" | translate }}
        </mat-radio-button>
      </mat-radio-group>

      <div
        class="gt2-light-green add-client-enterprise flex-row-right-right"
        style="width: 50px; height: 50px"
      >
        <button
          [matMenuTriggerFor]="menuClient"
          type="button"
          matTooltip="{{ 'SELECT_CLIENT.NEW_CLIENT_TOOLTIP' | translate }}"
          mat-icon-button
          class=""
          style="align-items: center; justify-content: center"
        >
          <mat-icon class="icon-mat-black" color="">add</mat-icon>
        </button>
      </div>
      <mat-menu #menuClient="matMenu">
        <button mat-menu-item (click)="onCreateClient()">
          {{ "SELECT_CLIENT.CREATE_CLIENT" | translate }}
        </button>
        <button mat-menu-item (click)="onCreateEnterprise()">
          {{ "SELECT_CLIENT.CREATE_ENTERPRISE" | translate }}
        </button>
        <button mat-menu-item (click)="onCreateClientEnterprise()">
          {{ "SELECT_CLIENT.CREATE_CLIENT_ENTERPRISE" | translate }}
        </button>
      </mat-menu>
    </div>

    <mat-form-field floatLabel="auto" class="search-field">
      <mat-label>{{ "SELECT_CLIENT.SEARCH" | translate }}</mat-label>
      <input #filter id="search" [(ngModel)]="filterValue" matInput />
      <button
        mat-button
        *ngIf="filterValue"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div #comboList class="container-border flex-column clients-list">
      <div *ngIf="isLoading" class="flex-column-center-center fxFlex-100p">
        <mat-spinner [diameter]="20" class=""></mat-spinner>
      </div>

      <div *ngIf="!isLoading && isEmpty" class="flex-column-center-center fxFlex-100p">
        Effectuez une recherche de votre client.
      </div>

      <div
        *ngIf="!isLoading && !isEmpty && (!clients || clients.length === 0)"
        class="flex-column-center-center fxFlex-100p"
      >
        <div class="font-size-20 my-16">
          {{ "SELECT_CLIENT.NO_CLIENTS" | translate }}
        </div>
      </div>

      <cdk-virtual-scroll-viewport
        *ngIf="!isLoading && !isEmpty && clients && clients.length > 0"
        #venueVScroll
        [itemSize]="50"
        class="venue-list-vscroll"
      >
        <div
          *cdkVirtualFor="let item of clients; trackBy: trackByUUID"
          class=""
        >
          <div
            class="client-child-item flex-row-space-between-center"
            (click)="onSelectClient(item)"
          >
            <div>{{ item.name_label }}</div>
            <mat-radio-button
              [checked]="selectedClient === item"
            ></mat-radio-button>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="mt-8 selected-label text-bold" *ngIf="selectedClient">
      {{ "SELECT_CLIENT.SELECTED_CLIENT" | translate }}
      {{ selectedClient.name_label }}
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      [disabled]="!selectedClient"
      (click)="onSameClientForBoth()"
      class="gt2-edit-button mr-8 ml-8 mt-4 mb-4"
    >
      <span
        class="same-client-both-label"
        [class.same-client-both--black]="!selectedClient"
        [class.same-client-both--grey]="selectedClient"
        >{{ "SELECT_CLIENT.SAME_CLIENT_BOTH" | translate }}</span
      >
    </button>
    <button
      mat-raised-button
      [disabled]="!selectedClient"
      (click)="onClientSelected()"
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "GENERIC.OK" | translate }}
    </button>
    <button
      mat-raised-button
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4 primary"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
